import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-js-day1',
  templateUrl: './js-day1.component.html',
  styleUrls: ['./js-day1.component.css']
})
export class JsDay1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
